@if (titleConfigs.length > 0) {
  @for (titleConfig of titleConfigs; track titleConfig; let i = $index) {
    <div class="d-flex gap-3 align-items-center">
      @if (
        !titleConfig.isEditable ||
        (titleConfig.isEditable && titleEditModeRecord[i])
      ) {
        @if (titleConfig.title) {
          <span
            [attr.data-tracker]="titleConfig?.dataTracker"
            [ngClass]="[
              titleConfig.type,
              titleConfig.type === 'Info' ? 'info-heading' : '',
              titleConfig.isEditable ? 'editable-title' : '',
              titleConfig.styleClass,
            ]"
            [pTooltip]="
              titleConfig.ellipsisConfig?.title?.enabled &&
              (titleConfig.title + '').length >
                titleConfig.ellipsisConfig.title.ellipsisMaxLength
                ? titleConfig.title + ''
                : ''
            "
            tooltipPosition="bottom"
            tooltipStyleClass="saas-tooltip"
            (click)="toggleEditModeIfApplicable(titleConfig, i)">
            @if (titleConfig.ellipsisConfig?.title?.enabled) {
              {{
                titleConfig.title + ""
                  | ellipsis
                    : titleConfig.ellipsisConfig.title.ellipsisMaxLength!
              }}
            } @else {
              <span [innerHTML]="titleConfig.title"></span>
            }
          </span>
        }
      }
      @if (titleConfig.isEditable && !titleEditModeRecord[i]) {
        <div class="d-flex title-edit-container">
          <input
            #titleInput
            class="{{ titleConfig.type }} {{
              titleConfig.type === 'Info' ? 'info-heading' : ''
            }} lh-base {{ titleConfig.styleClass }}"
            [value]="titleConfig.title"
            (blur)="toggleEditModeIfApplicable(titleConfig, i)"
            (change)="
              emitTitleChangeEvent($event.target.value);
              toggleEditModeIfApplicable(titleConfig, i)
            " />
        </div>
      }
      @if (titleConfig.subTitle) {
        <span
          [ngClass]="titleConfig.subTitleStyleClass || ''"
          [pTooltip]="
            titleConfig.ellipsisConfig?.subTitle?.enabled &&
            (titleConfig.subTitle + '').length >
              titleConfig.ellipsisConfig.subTitle.ellipsisMaxLength
              ? titleConfig.subTitle + ''
              : ''
          "
          tooltipPosition="bottom"
          tooltipStyleClass="saas-tooltip"
          [innerHtml]="titleConfig.subTitle"></span>
      }
      @if (titleConfig.icons?.length) {
        @for (icon of titleConfig.icons; track icon) {
          <em
            class="{{ icon.class }}"
            [ngClass]="icon.styleClass || ''"
            pTooltip="{{ icon.tooltip }}"
            showDelay="800"
            tooltipStyleClass="saas-tooltip"
            tooltipPosition="bottom"
            [escape]="!icon.isHtmlTooltip">
            {{ icon.content }}
          </em>
        }
      }
      @if (titleConfig.chips?.length) {
        @for (chip of titleConfig.chips; track chip) {
          <m-pill [text]="chip.label" [type]="chip.type"></m-pill>
        }
      }
    </div>
  }
}
